import { MenuItem, Select, FormControl, Menu, Button, CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page';
import { getBranchList, getBudgetYearList } from '../setting/services/settingApi';
import { REPORT_CONFIG } from './config';
import api from '../../api/api'
import { saveAs } from 'file-saver';
export default function ReportPlanProduction() {
    const [branchs, setBranchs] = useState([])
    const [reports, setReports] = useState([])
    const [s, setS] = useState('')
    const [seasons, setSeasons] = useState()
    const [BudgetYearList, setBudgetYearList] = useState([])
    const [budgetyear, setBudgetYear] = useState('')
    const [loadingDownload, setloadingDownload] = useState(false);
    const [loading, setloading] = useState(false);
    const [error, setError] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        if (budgetyear.length === 0) {
            setError(true)
        } else {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    function getTarget(target, Branch) {
        return target[+Branch?.BranchNo] / 1000;
    }

    function getBranchSum(reports, Branch) {
        return reports.map(e => e.Targets[+Branch?.BranchNo]).reduce((a, b) => a + b, 0) / 1000;
    }




    function getSummary(target) {
        let sum = 0;

        for (const branch of branchs) {
            sum += +target[+branch.BranchNo];
        }

        return sum / 1000;
    }

    function getTotalSum(reports) {
        let sum = 0;
        for (const row of reports) {
            for (const branch of branchs) {
                sum += +row.Targets[+branch.BranchNo];
            }
        }

        return sum / 1000;
    }


    async function LoadBBudgetYear() {
        getBudgetYearList(setBudgetYearList)
    }

    function ChangeBudgetYear(event) {
        const year = event;
        if (year) {
            const rainYear = new Date(+year - 1, 0, 1);
            const dryYear = new Date((+year), 0, 1);
            const seasons = [
                {
                    value: 'ฝน',
                    year: rainYear.getFullYear()
                },
                {
                    value: 'แล้ง',
                    year: dryYear.getFullYear()
                }
            ]
            setSeasons(seasons)
            setS('');
        } else {
            setSeasons([])
            setS('')
        }

    }
    useEffect(() => {
        getBranchList(null, setBranchs)
        LoadBBudgetYear()
        // getCatalogList(null, setCatalog)
        // LoadReport()

    }, [])
    async function getReportPlanProduction(body, mode, format) {

        const url = `${REPORT_CONFIG.requests.getReportPlanProduction.url}/${mode}`;


        let _params = '';
        let _y = '';
        let _s = '';

        let _format = '';



        if (body.y) {
            _y = 'y=' + (body.y !== '-' ? body.y : '');
        }

        if (body.s) {
            _s = '&s=' + (body.s !== '-' ? body.s : '');
        }


        if (format) {
            _format = '&format=' + format;
        }
        _params = '?' + _y + _s + _format
        if (mode === 'file') {
            setloadingDownload(true)
            const res = await api.get(url + _params, { responseType: 'arraybuffer' })
            const data = res.data
            if (format) {
                const blob = new Blob([data], { type: 'application/pdf' });
                saveAs(blob, 'รายงานศักยภาพและแผนผลิตเมล็ดพันธุ์ข้าวประจำปี (กมข-20401)');

            } else {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'รายงานศักยภาพและแผนผลิตเมล็ดพันธุ์ข้าวประจำปี (กมข-20401)');
            }
            setloadingDownload(false)
        } else {
            setloading(true)
            const res = await api.get(url + _params)
            const data = res.data.result
            setReports(data)
            setloading(false)
        }

    }
    async function LoadReport() {
        const body = {
            y: budgetyear,
            s: s || undefined,
        };
        if (budgetyear.length === 0) {
            setError(true)
        } else {
            getReportPlanProduction(body, 'data');
        }


    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid p-0">
                    <form>
                        <div class="row  no-gutters">

                            <div class="col-12 col-lg-12">
                                <div class="row no-gutters">
                                    <div class="col-12 header-row border-1 ">
                                        ตัวกรอง
                                    </div>
                                </div>
                                <div class="row no-gutters p-2 border-1">
                                    <div class="col-3">

                                        <label class="labelInput">ปีงบประมาณ</label>

                                        <Box className={`backgroundField ${error ? 'error' : ''}`} >
                                            <FormControl variant="standard" fullWidth>

                                                <Select value={budgetyear || '-'}
                                                    onChange={e => {
                                                        setBudgetYear(e.target.value)
                                                        ChangeBudgetYear(e.target.value)
                                                    }} disableUnderline
                                                    onBlur={e => {
                                                        if (!e.target.value) {
                                                            setError(true)
                                                        } else {
                                                            setError(false)
                                                        }
                                                    }}
                                                    MenuProps={{
                                                        style: {
                                                            maxHeight: 400,
                                                        },
                                                    }}>
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {BudgetYearList?.map((x) => (
                                                        <MenuItem value={x?.BudgetYear}>{x?.BudgetYear}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        {error && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกปีงบประมาณ</span>}
                                    </div>


                                    <div class="col-3">
                                        <label class="labelInput">ฤดู</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={s || '-'} onChange={e => setS(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {seasons?.map((x) => (
                                                        <MenuItem value={x?.value}>{x?.value} {x?.year}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>

                                    </div>

                                    <div class="col-3 d-flex align-items-center">
                                        <Button onClick={LoadReport} disabled={loading ? true : false} variant='contained' className="ButtomSearch">{loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ค้นหา'} </Button>

                                    </div>

                                </div>
                            </div>
                            <div class="col-12 col-lg-12">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between header-row border-1 ">
                                        <div>
                                            รายงานศักยภาพและแผนผลิตเมล็ดพันธุ์ข้าวประจำปี (กมข-20401)
                                        </div>
                                        <Button variant='contained'
                                            id="basic-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disabled={loadingDownload ? true : false}
                                            onClick={handleClick}>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            PaperProps={{  
                                                style: {  
                                                  width: 100,  
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    y: budgetyear,
                                                    s: s || undefined,
                                                };
                                                // setFormat('')
                                                getReportPlanProduction(body, 'file')

                                                handleClose()
                                            }}>Excel</MenuItem>
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    y: budgetyear,
                                                    s: s || undefined,
                                                };
                                                // setFormat('pdf')
                                                getReportPlanProduction(body, 'file', 'pdf')

                                                handleClose()
                                            }}>Pdf</MenuItem>
                                        </Menu>
                                    </div>

                                </div>
                                <div class="row no-gutters border-1 pt-3">
                                    <div class="text-end" style={{ color: 'red' }}>
                                        ( หน่วย : ตัน )
                                    </div>
                                    <div class="report col-12">
                                        <div class="table-responsive-sm" style={{ height: 'auto' }}>
                                            <table class="table table-sm table-bordered table-hover">
                                                <thead class="sticky-thead">
                                                    <tr>
                                                        <th scope="col" rowspan="2">ที่</th>
                                                        <th scope="col" rowspan="2">ชนิดข้าว</th>
                                                        <th scope="col" rowspan="2">ประเภทข้าว</th>
                                                        <th scope="col" rowspan="2">พันธุ์ข้าว</th>
                                                        <th scope="col" colspan={branchs?.filter(x => x.BranchNo !== '00')?.length}>ศูนย์เมล็ดพันธุ์ข้าว</th>
                                                        <th scope="col" rowspan="2">รวม</th>
                                                    </tr>
                                                    <tr >
                                                        {branchs?.filter(x => x.BranchNo !== '00')?.map((branch) => (
                                                            <th scope="col" class="th-sticky" > {branch?.InitialsName}.</th>
                                                        ))}

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {reports?.map((report, i) => (

                                                        <tr class="cp">
                                                            <td>{i + 1}</td>
                                                            <td>{report?.TypeName}</td>
                                                            <td>{report?.GroupName}</td>
                                                            <td>{report?.CatalogName}</td>

                                                            {branchs?.filter(x => x.BranchNo !== '00')?.map((branch) => (
                                                                <td >{getTarget(report?.Targets, branch).toLocaleString()}</td>
                                                            ))}
                                                            <td>{getSummary(report?.Targets).toLocaleString()}</td>



                                                        </tr>
                                                    ))}

                                                </tbody>
                                                <thead class="sticky-tfooter">
                                                    <tr>
                                                        <th scope="col" colspan="4">รวม</th>
                                                        {branchs?.filter(x => x.BranchNo !== '00')?.map((branch) => (

                                                            <th >{getBranchSum(reports, branch).toLocaleString()}</th>
                                                        ))}
                                                        <th>{getTotalSum(reports).toLocaleString()}</th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {
                                    reports.length === 0 &&
                                    <div class="row" >
                                        <div class="col-12">
                                            <div class="not-found">
                                                ไม่พบข้อมูล
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div >

                        </div >

                    </form >
                </div >
            </Page >
        </div >
    )
}
